import {
  FEATURE_FLAGS,
  useFeatureFlag,
} from '../../../../../config/featureFlags';
import ProwlChatWidgetLegacy from './ProwlChatWidgetLegacy';
import ProwlChatWidgetV2 from './ProwlChatWidgetV2';

/**
 * Gated by Unleash flag `prowl.v2.customer` (task requirement 9, default
 * OFF). With the flag off this renders ProwlChatWidgetLegacy — the
 * pre-rewire widget, untouched — so flag-off behaviour is byte-for-byte
 * unchanged from before this PR.
 */
const ProwlChatWidget = () => {
  const isV2Enabled = useFeatureFlag(FEATURE_FLAGS.prowlV2Customer);
  return isV2Enabled ? <ProwlChatWidgetV2 /> : <ProwlChatWidgetLegacy />;
};

export default ProwlChatWidget;
